/**
 *
 * @Description:
 *
 * generates horizontal Legend according to the data : color and label
 *
 */

import React, {Component} from 'react'

// styles
import classNames from 'classnames'

// default component class name
const COMPONENT_CLASS = 'nmc-h-legend'

export default class HorizontalLegend extends Component {

  render () {
    const {className} = this.props

    const legendClassNames = classNames(COMPONENT_CLASS, className)

    return (
      <div className={classNames(legendClassNames)}>
        {this.props.children}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/HorizontalLegend/HorizontalLegend.js